import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

export const ChangePasswordGate = () => {
  const { user, changePassword } = useAuth();
  const [pw1, setPw1] = useState('');
  const [pw2, setPw2] = useState('');
  const [saving, setSaving] = useState(false);

  if (!user || !user.must_change_password) return null;

  const submit = async () => {
    if (pw1.length < 6) return toast.error('Password must be at least 6 characters');
    if (pw1 !== pw2) return toast.error('Passwords do not match');
    setSaving(true);
    const res = await changePassword(pw1);
    setSaving(false);
    if (res.success) toast.success('Password changed. Welcome!');
    else toast.error(res.error || 'Failed');
  };

  return (
    <Dialog open={true} onOpenChange={() => {}}>
      <DialogContent className="max-w-md" onEscapeKeyDown={(e) => e.preventDefault()} onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader><DialogTitle>Change your temporary password</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-slate-600">Your admin set a temporary password for you. Please choose a new one to continue.</p>
          <div><Label>New Password</Label><Input data-testid="new-password-input" type="password" value={pw1} onChange={e => setPw1(e.target.value)} /></div>
          <div><Label>Confirm Password</Label><Input data-testid="confirm-password-input" type="password" value={pw2} onChange={e => setPw2(e.target.value)} /></div>
        </div>
        <DialogFooter>
          <Button data-testid="submit-new-password-btn" onClick={submit} disabled={saving} style={{ backgroundColor: '#1E3A8A' }}>
            {saving ? 'Saving…' : 'Set New Password'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
